import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69b9d9d57d947e001447dc1b/incade/node_modules/next/dist/client/app-dir/link.js");
